import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';

@Injectable()
export class ModifiersService {
  public modifierGroups;
  public modifiers;

  constructor(private _http: HttpClient) {}

  public getAllModifiers() {
    return this._http
      .get('/api/modifiers')
      .map((response: Response) => response)
      .toPromise()
      .catch(this.handleError);
  }

  public getAllModifierGroups() {
    return this._http
      .get('/api/modifier-groups')
      .map((response: Response) => response)
      .toPromise()
      .catch(this.handleError);
  }

  public updateModifiersSql(modifier) {
    return this._http
      .put('/api/modifiers', modifier)
      .map((response: Response) => response)
      .toPromise()
      .catch(error => {
        console.log('could not update the item', error);
      });
  }

  public updateModifierGroupSql(modifierGroup) {
    return this._http
      .put('/api/modifier-groups', modifierGroup)
      .map((response: Response) => response)
      .toPromise()
      .catch(error => {
        console.log('could not update the item', error);
      });
  }

  // public updateModifiers(modifier) {
  //   let key = modifier.$key;
  //   this.db
  //     .list('/modifiers')
  //     .update(key, modifier)
  //     .then(result => {})
  //     .catch(error => {
  //       console.log('could not update the item', error);
  //     });
  // }

  // public updateModifierGroup(group) {
  //   let key = group.$key;
  //   this.db
  //     .list('/modifierGroups')
  //     .update(key, group)
  //     .then(result => {})
  //     .catch(error => {
  //       console.log('could not update the item', error);
  //     });
  // }

  // getAllModifierGroups() {
  //   this.modifierGroups = this.db.list('/modifierGroups');
  //   return this.modifierGroups;
  // }

  // getAllModifiers() {
  //   this.modifiers = this.db.list('modifiers');
  //   return this.modifiers;
  // }

  private handleError(error) {
    console.error(error);
    if (error.status == 404) {
      // alert('Please change all references to /confidential/fixture/work.json to /fixture/work.json in the work.service.ts file');
    }
    return Observable.throw(error.json().error || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/modifiers/modifiers.service.ts